import { styled } from "@vitality-ds/system";

import DocsBox from "../DocsBox";
import { WRAPPER_WIDTH } from "../Wrapper/constants";
import { TOC_WIDTH } from "../Wrapper/globalStyle";

export const Container = styled(DocsBox, {
  width: "100%",
  maxWidth: WRAPPER_WIDTH,
  marginInline: "auto",
  paddingInline: "$xxl",
  // clears the home page's floating header, which sits $lg from the top
  paddingTop: "$lg",

  variants: {
    reserveTocSpace: {
      true: {
        "@bp2": {
          paddingRight: TOC_WIDTH,
        },
      },
    },
  },
});

export const Paragraph = styled("span", {
  display: "block",
  "& + &": {
    marginTop: "$md",
  },
});
